<script>
import MixedGridFiltersItemList from '@phoenix/mixins/components/mixedGrid/MixedGridFiltersItemList';

export default {
  mixins: [MixedGridFiltersItemList],

  emits: ['onItemSelected'],

  computed: {
    value: {
      get() {
        const value = this.activeFilters[this.filter.id];
        if (Array.isArray(value)) {
          return value[0];
        }
        return value;
      },
      set(value) {
        this.$emit('onItemSelected', this.filter.id, value);
      },
    },
  },
};
</script>

<template>
  <div class="field--select__wrapper" data-cy="mixed-grid-filter-select" :data-cy-filter-id="filter.id">
    <label :for="`filtersub-desktop-${filter.id}`" :data-cy-filter-value="filter.label" class="sr-only">
      {{ filter.label }}
    </label>
    <select
      :id="`filtersub-desktop-${filter.id}`"
      v-model="value"
      :data-cy="`filtersub-desktop-${filter.id}`"
      :data-property="filter.id"
      :data-value="1"
      :name="`filtersub-desktop-${filter.id}`"
      class="field field--select"
    >
      <template v-for="item in filter.items">
        <option v-if="!itemIsDisabled(item)" :key="item.value" :value="item.value">
          {{ item.label }}
        </option>
      </template>
    </select>
  </div>
</template>
